import { useEffect } from 'react';

import { useQueryClient } from '@tanstack/react-query';

import { useTotalBalanceStore } from '@/entities/currency-account';
import { usePaymentsController } from '@/entities/payment/model';
import { usePersonalStore } from '@/entities/user';

import { KybStepStatus, VabsPaymentStatus } from '@/shared/api';
import { completeTokens, getNewToken } from '@/shared/api/apollo/client';
import { EQueryKeys } from '@/shared/config';

import { wsService } from '.';
import { EWsMsgPatterns } from './config';
import { useComplianceAutoOpenStore } from '@/features/compliance';

export const useWsClient = () => {
  const user = usePersonalStore((state) => state.user);
  const company = usePersonalStore((state) => state.company);
  const setShouldOpen = useComplianceAutoOpenStore((state) => state.setShouldAutoOpenComplianceModal)
  const queryClient = useQueryClient();
  const setBalance = useTotalBalanceStore((state) => state.setBalance);
  const { refetchTxs } = usePaymentsController(
    company?.status === KybStepStatus.Successful,
  );
  useEffect(() => {
    if (user) {
      wsService?.client?.subscribe({
        type: 'token_expired',
        callback: async (msg) => {
          try {
            const tokens = await getNewToken();
            completeTokens({ ...tokens });
          } catch (e) {
            console.log('refresh error');
          }
        },
      });
      wsService?.client?.subscribe({
        type: 'notification',
        callback: async (msg) => {
          switch (msg.pattern) {
            case EWsMsgPatterns.BALANCE_UPDATED:
              {
                if (msg.data?.totalBalance) {
                  setBalance({ amount: msg.data?.totalBalance, symbol: '$' });
                }
                await queryClient.invalidateQueries({
                  queryKey: ['vabs-accounts'],
                });
                await queryClient.invalidateQueries({
                  queryKey: ['total-balance'],
                });
              }
              break;
            case EWsMsgPatterns.PAYMENT_CREATED:
              {
                await refetchTxs();
              }
              break;
            case EWsMsgPatterns.PAYMENT_UPDATED:
              {
                await refetchTxs();
                if (msg?.data?.status === VabsPaymentStatus.NeedAction) {
                  setShouldOpen(true)
                }
              }
              break;
            case EWsMsgPatterns.DOC_UPDATED:
              {
                await queryClient.refetchQueries({
                  queryKey: ['my-docs'],
                });
              }
              break;
            case EWsMsgPatterns.KYB_APPROVED:
              {
                await queryClient.refetchQueries({
                  queryKey: [EQueryKeys.CompaniesQueryKey],
                });
              }

              break;
            case EWsMsgPatterns.KYB_REJECTED:
              {
                await queryClient.refetchQueries({
                  queryKey: [EQueryKeys.CompaniesQueryKey],
                });
              }

              break;
          }
        },
      });
    } else {
      wsService?.client?.unsubscribe();
    }

    return () => wsService?.client?.unsubscribe();
  }, [user]);
};
